import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CheckCircle as CheckCircleIcon } from 'react-feather'
import { Button } from '@material-ui/core'

import {
  ConfirmationDialog,
  Container,
  ContentHeader,
  LoadingFeedback,
  Page,
} from 'components'
import { Form } from './components'

import useFetch from 'hooks/useFetch'
import usePhishing from 'hooks/usePhishing'
import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'
import { history } from 'service'
import { routes } from 'Routes'
import constants from 'constants/index'

const PhishingShow = () => {
  const { phishingId } = useParams()
  const {
    phishing,
    setPhishing,
    setActiveStep,
    setLastActiveStep,
    setIsReadOnly,
  } = usePhishing()
  const snackbar = useSnackbar()

  const [finalizeOpen, setFinalizeOpen] = useState(false)
  const [finalizeLoading, setFinalizeLoading] = useState(false)

  const { response, error, isLoading, refresh } = useFetch(
    service.dponet.phishingCampaigns.show,
    phishingId,
  )

  useEffect(() => {
    if (!response) return
    const campaign = response?.data?.phishingCampaign

    if (!campaign) {
      history.push(routes.phishing.all)
      return
    }

    const recipients = (campaign.recipientGroups || []).flatMap(
      (group) => group.users,
    )

    setPhishing({ ...campaign, recipients })
    setIsReadOnly(true)

    setActiveStep(0)
    setLastActiveStep(constants.phishing.FORM_STEPS_VIEW.length)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response])

  useEffect(() => {
    if (!error) return
    snackbar.open({
      message: 'Erro ao carregar campanha.',
      variant: 'error',
    })
    history.push(routes.phishing.all)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  const canFinalize = phishing?.status === constants.phishing.SENDING_STATUS_ID

  const handleFinalize = async () => {
    setFinalizeLoading(true)
    try {
      await service.dponet.phishingCampaigns.finalize(phishingId)
      snackbar.open({
        message: 'Campanha finalizada com sucesso.',
        variant: 'success',
      })
      setFinalizeOpen(false)
      refresh()
    } catch (finalizeError) {
      snackbar.open({
        message:
          finalizeError?.response?.data?.error ||
          'Erro ao finalizar a campanha. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setFinalizeLoading(false)
    }
  }

  return (
    <Page title="Visualizar Campanha">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Visualizar Campanha">
          {canFinalize && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<CheckCircleIcon size={20} />}
              onClick={() => setFinalizeOpen(true)}
            >
              Finalizar campanha
            </Button>
          )}
        </ContentHeader>
        {!isLoading && <Form />}
      </Container>

      <ConfirmationDialog
        open={finalizeOpen}
        setOpen={setFinalizeOpen}
        text="Deseja finalizar esta campanha? Ela será encerrada mesmo com participantes que ainda não interagiram. Esta ação não pode ser desfeita."
        textButton="Finalizar"
        loading={finalizeLoading}
        actionAcceptButton={handleFinalize}
      />
    </Page>
  )
}

export default PhishingShow
